import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UnitwatermeterlistModel, Unittypemodel, Consumertypemodel } from '../modles/unitwatermeter.model';
import { UnitWaterService } from '../services/unitwatermeter.services';
import { MessageService } from 'primeng/api';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { EffluentwatermeterService } from '../services/effluentwatermeter.services';
import { EffluentwatermeterModel } from '../modles/effluentwatermeter.model';
import { ConsumptionService } from '../services/consumption.services';
import { Consumptionmodel,UnitMasterListModel } from '../modles/consumptions.model';
import { Organization } from '../../admin/models/organization.model';
import { OrganizationService } from '../../admin/organization.service';
@Component({
  selector: 'app-consumptionmodification',
  templateUrl: './consumptionmodification.component.html',
  styleUrls: ['./consumptionmodification.component.css']
})
export class ConsumptionmodificationComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  dtOptions: any = {};
  effwaterlist: EffluentwatermeterModel[] = [];
  dtTrigger: Subject<any> = new Subject();
  Unitval="";  fromDate: Date;
  unitwaterdatalst: UnitwatermeterlistModel[] = [];
  consumptionlist: Consumptionmodel[] = [];
  organizations: Array<Organization>;
  constructor(private organizationService: OrganizationService,private fb: FormBuilder, private consumptserivce: ConsumptionService,  private unitservice: UnitWaterService, private messageService: MessageService) {
    this.retrieveunitdatadetails();
  }

  ngOnInit() {
    this.getOrganizations();
    this.consumptserivce.ConsumptionreatedObservable.subscribe((resp: boolean) => {
      if (resp) {
        this.GetConsumption();
      }
    });
    this.dtOptions = {
      dom: 'Bfrtip',
      searching: true,
      "language": {
        "emptyTable": "No data available"
      },  
      buttons: [
        {
          extend: 'print',
          text: '  <i class="fa fa-print"></i> ',
          titleAttr: 'Print'
        },
        {
          extend: 'pdf',
          title: 'Consumer Types',
          filename: 'consumer_types-' + this.formatDate(new Date()),
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5]
          },
          text: '<i class="fa fa-file-pdf-o"></i> ',
          orientation: 'landscape',
          titleAttr: 'Pdf'

        }, {
          extend: 'excel',
          title: 'Consumer Types',
          filename: 'consumer_types-' + this.formatDate(new Date()),
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5]
          },
          text: '<i class="fa fa-file-excel-o"></i> ',
          titleAttr: 'Excel'
        }]


    };

  }
  GetConsumption(){
    const fromDate = this.formatDate(this.fromDate);

    this.consumptserivce.GetConsumptionList(fromDate,Number(this.Unitval)).subscribe((resp: any) => {
      this.consumptionlist=resp;
    });
  }
  retrieveunitdatadetails() {
    this.unitservice.getallUnitWaterList().subscribe((resp: any) => {
      if (resp) {
        this.unitwaterdatalst = resp.UnitMasterList;
      }
    });
  }
  
  editConsuption(Id: number) {
    this.consumptserivce.editConsumptionRequest(Id);
  }
  getOrganizations() {
    this.organizationService.getOrganizationUnits().subscribe((response: any) => {
      this.organizations = response.MOrganiserDetails;
    });
  }
  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

}
